import React from "react";

import type { AppProps } from "next/app";

import { useEffect } from "react";
import { useRouter } from "next/router";
import axios from "axios";

import { PageTransition } from 'next-page-transitions'

import Loader from '../components/Transition'

import * as gtag from "../components/Analytics";

import Footer from "../components/Footer";
import Nav from "../components/Nav";

import "../styles/Globals.scss";

const MyApp = ({ Component, pageProps }: AppProps) => {
  const router = useRouter();

  useEffect(() => {
    window.history.scrollRestoration = "manual";

    const handleRouteChange = (url: URL) => {
      gtag.pageview(url);
    };

    router.events.on("routeChangeComplete", handleRouteChange);

    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, []);

  const getUser = async () => {
    try {
      const res = await axios.get(
        `${process.env.NEXT_PUBLIC_API}auth/validar`, { headers: { Authorization: sessionStorage.token } }
      );
      sessionStorage.nome = res.data.usuario.nome
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (router.query?.t) {
      sessionStorage.token = router.query.t
      getUser()
      if (router.query.id) {
        history.replaceState(null, ``, `/seguros/${router.query.id}/`)
      } else {
        history.replaceState(null, '', `${router.route}`)
      }
    } else if (router.query.d) {
      sessionStorage.clear()
      if (router.query.id) {
        history.replaceState(null, '', `/seguros/${router.query.id}/`)
      } else {
        history.replaceState(null, '', `${router.route}`)
      }
    }
  }, [router])

  return (
    <>
      <Nav />
      <PageTransition
        timeout={400}
        classNames="page-transition"
        loadingComponent={<Loader />}
        loadingDelay={500}
        loadingTimeout={{
          enter: 400,
          exit: 0,
        }}
        loadingClassNames="loading-indicator"
      >
        <Component {...pageProps} />
      </PageTransition>
      <Footer />
    </>

  )
};

export default MyApp;
